const API_BASE = '/api/admin/subscriptions';

function authHeaders() {
  const token = localStorage.getItem('token');
  return { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };
}

function handleResponse(r) {
  if (!r.ok) throw new Error(`API error ${r.status}`);
  return r.json();
}

export const adminSubscriptionApi = {
  getDashboard: () =>
    fetch(`${API_BASE}/dashboard`, { headers: authHeaders() }).then(handleResponse),

  listSubscribers: (params) =>
    fetch(`${API_BASE}/subscribers?${new URLSearchParams(params)}`, { headers: authHeaders() }).then(handleResponse),

  getSubscriber: (userId) =>
    fetch(`${API_BASE}/subscribers/${userId}`, { headers: authHeaders() }).then(handleResponse),

  listSubscriptions: (params) =>
    fetch(`${API_BASE}/subscriptions?${new URLSearchParams(params)}`, { headers: authHeaders() }).then(handleResponse),

  forceStatus: (subId, status, reason) =>
    fetch(`${API_BASE}/subscriptions/${subId}/force-status`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ status, reason }),
    }).then(handleResponse),

  extendSubscription: (subId, days, reason) =>
    fetch(`${API_BASE}/subscriptions/${subId}/extend`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ days, reason }),
    }).then(handleResponse),

  grantPlan: (userId, planSlug, reason, days) =>
    fetch(`${API_BASE}/users/${userId}/grant-plan`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ plan_slug: planSlug, reason, duration_days: days }),
    }).then(handleResponse),

  listTransactions: (params) =>
    fetch(`${API_BASE}/transactions?${new URLSearchParams(params)}`, { headers: authHeaders() }).then(handleResponse),

  getTransaction: (id) =>
    fetch(`${API_BASE}/transactions/${id}`, { headers: authHeaders() }).then(handleResponse),

  refund: (txId, amount, reason) =>
    fetch(`${API_BASE}/transactions/${txId}/refund`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ amount, reason }),
    }).then(handleResponse),

  listWebhooks: (params) =>
    fetch(`${API_BASE}/webhooks?${new URLSearchParams(params)}`, { headers: authHeaders() }).then(handleResponse),

  getWebhook: (id) =>
    fetch(`${API_BASE}/webhooks/${id}`, { headers: authHeaders() }).then(handleResponse),

  retryWebhook: (id) =>
    fetch(`${API_BASE}/webhooks/${id}/retry`, {
      method: 'POST',
      headers: authHeaders(),
    }).then(handleResponse),

  listPlans: () =>
    fetch(`${API_BASE}/plans`, { headers: authHeaders() }).then(handleResponse),

  createPlan: (data) =>
    fetch(`${API_BASE}/plans`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(data),
    }).then(handleResponse),

  updatePlan: (id, data) =>
    fetch(`${API_BASE}/plans/${id}`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify(data),
    }).then(handleResponse),

  deactivatePlan: (id) =>
    fetch(`${API_BASE}/plans/${id}`, {
      method: 'DELETE',
      headers: authHeaders(),
    }).then(handleResponse),

  listAuditLogs: (params) =>
    fetch(`${API_BASE}/audit-logs?${new URLSearchParams(params)}`, { headers: authHeaders() }).then(handleResponse),

  exportSubscribers: (params) =>
    fetch(`${API_BASE}/export/subscribers?${new URLSearchParams(params)}`, { headers: authHeaders() }),

  exportTransactions: (params) =>
    fetch(`${API_BASE}/export/transactions?${new URLSearchParams(params)}`, { headers: authHeaders() }),
};
